import { BodyText, Spinner, SpinnerProps } from '@servicetitan/design-system';

import { Container } from './LoadingIndicator.styled';

type Props = SpinnerProps & {
  show: boolean;
  title?: string;
};

export const LoadingIndicator = ({ show, title, ...spinnerProps }: Props) => {
  if (!show) {
    return null;
  }

  return (
    <Container>
      {title && <BodyText subdued>{title}</BodyText>}
      <Spinner size='tiny' {...spinnerProps} />
    </Container>
  );
};

export default LoadingIndicator;
